define('common/models/appstate',['require','exports','module','backbone','../../modules/lp_integration/models/integration_correodirect','env','./csv_file','ThemesHelper'],function (require, exports, module) {
  'use strict';
  //AppState is a singleton model used across the application routers
  var Backbone = require('backbone'),
    CorreoDirectModel = require('../../modules/lp_integration/models/integration_correodirect'),
    config = require('env'),
    CsvFile = require('./csv_file'),
    ThemesHelper = require('ThemesHelper');

  var AppState = Backbone.Model.extend({
    defaults: {
      /** used to allow/disallow leaving the editor page **/
      navigationAllowed: true,
      navigationConfirmMessage: '¿Está seguro?',
      /** used to enable/disable keyboard event capturing **/
      editor_props_open: false,
      allPlatforms: false,
    },

    initialize: function (attrs, options) {
      this._appStorage = {};
      this._expirationCb = undefined;
      this._remindersCb = undefined;
      this._companyInfoStatus = false;
      this._companyInfo = new Backbone.Model({
        correo_direct_is_available: false,
      });
      this._csvFile = new CsvFile();
    },

    /** keep a reference to the editor variant model **/
    setVariant: function (ref) {
      this.set('editor_variant', ref);
    },

    getVariant: function () {
      return this.get('editor_variant');
    },

    /** keep editor view state - is the user editing properties? **/
    isPropsPopUpOpen: function () {
      return !!this.get('editor_props_open');
    },

    setPropsPopUpOpen: function (isOpen) {
      this.set('editor_props_open', isOpen);
    },

    /** create page from template **/
    //appStorage acts as an app-wide key-value container
    //so that any module can share data with others
    //Example: AppState.saveItem("newPage", newPageModel)
    //         var savedModel = AppState.getItem("newPage")
    saveItem: function (name, item) {
      this._appStorage[name] = item;
    },

    getItem: function (name) {
      return this._appStorage[name];
    },

    /** navigation with dirty views */
    toggleNavigation: function (isAllowed, message) {
      if (isAllowed === undefined) {
        isAllowed = true;
      }
      this.set('navigationAllowed', isAllowed);
      if (message) {
        this.set('navigationConfirmMessage', message);
      }
      if (!isAllowed) {
        //store current url
        this.set('navigationCurrentUrl', window.location.pathname);
      }
    },

    setNavigationConfirmMessage: function (message) {
      this.set('navigationConfirmMessage', message);
    },

    onBeforeUnload: function (e) {
      if (this.get('changing')) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        e.preventDefault();
        this.set('changing', false);
        return void 0;
      }

      if (config.disablePageRefreshWarning) {
        return void 0;
      }

      if (this._shouldPrevent()) {
        return this.get('navigationConfirmMessage');
      } else {
        //release reference to the variant
        this.unset('editor_variant');
      }
    },

    _shouldPrevent: function () {
      return this.get('navigationAllowed') === false;
    },

    initCompanyInfo: function (info) {
      this.setCompanyInfo(info);
      if (this._expirationCb && this.hasExpired()) this._expirationCb();
      if (this._remindersCb && this.isAdminFreemium() && !this.isEmBlue()) this._remindersCb();
    },

    setCompanyInfo: function (info) {
      this._companyInfo.set(info);
      this._companyInfoStatus = true;
    },

    isCorreoDirectAvailable: function () {
      return this._companyInfo.get('correo_direct_is_available');
    },

    isCorreoDirectActive: function (pageId) {
      var correodirectData = new CorreoDirectModel({ id: 'correodirect' }, { pageId: pageId });
      return correodirectData.fetch();
    },

    hasMDirectorServiceEnabled: function () {
      return this._companyInfo.get('hasMDirectorServiceEnabled');
    },

    getCountryId: function () {
      return this._companyInfo.get('countryId');
    },
    getMaxVisits: function () {
      return this._companyInfo.get('maxVisits');
    },

    isAppSumo: function () {
      return this._companyInfo.get('isAppSumo');
    },
    isEmBlue: function () {
      return this._companyInfo.get('isEmBlue');
    },

    getAllPlatforms: function () {
      var allPlatforms = this.get('allPlatforms');
      this.set('allPlatforms', false);
      return allPlatforms;
    },

    setCsvToDownload: function (info) {
      this._csvFile.set(info);
    },

    unsetCsvToDownload: function () {
      this._csvFile.reset();
    },
    isMaxDomainsExceed: function (num) {
      return num >= this._getMaxDomains();
    },
    _getMaxDomains: function () {
      return this._companyInfo.get('maxDomains') ? this._companyInfo.get('maxDomains') : 0;
    },
    onExpiration: function (cb) {
      if (typeof cb === 'function') {
        this._expirationCb = cb;
      }
    },
    onReminder: function (cb) {
      if (typeof cb === 'function') {
        this._remindersCb = cb;
      }
    },
    hasExpired: function () {
      return this.isFreemium() && this._now() >= this._getTrialEndTime();
    },
    isFreemium: function () {
      return this._companyInfo.get('type') && this._companyInfo.get('type') === 'freemium';
    },
    _now: function () {
      return new Date().getTime();
    },
    _getTrialEndTime: function () {
      return new Date(this._companyInfo.get('endDate')).getTime();
    },
    markAsDisplayed: function () {
      this._setCookie(true);
    },
    _setCookie: function (shown) {
      document.cookie = 'trialpopupshown=' + shown + '; path=/';
    },
    hasBeenDisplayed: function () {
      return this._readCookie();
    },
    _readCookie: function () {
      var value = document.cookie.match(/trialpopupshown=(true|false)/);
      return value && value[1] === 'true';
    },
    getChatbaseToken: function () {
      return this._companyInfo.get('chatbase_token');
    },
    getGroupName: function () {
      return this._companyInfo.get('group_name');
    },
    getPlan: function () {
      return this._companyInfo.get('plan');
    },
    getEmail: function () {
      return this._companyInfo.get('email');
    },
    getFirstName: function () {
      return this._companyInfo.get('firstname');
    },
    getLastname: function () {
      return this._companyInfo.get('lastname');
    },
    getRolId: function () {
      return this._companyInfo.get('rolId');
    },
    isAdminFreemium() {
      return this.getRolId() === 'adm_mdirector_newfree';
    },
  });

  return new AppState();
});

